// extracted by mini-css-extract-plugin
export default {"colorPickerButton":"t2L5z4PWN3Z5WfhGME8nBg==","colorPickerButtonTransparentContainer":"_1uGQnbUpacDIE-XqFrxeoA=="};